import { gql } from "@apollo/client";

const UPDATE_FIRM = gql`
  mutation UpdateEntity($entityId: ID!, $args: CombinedUpdateEntityInput) {
    updateEntity(entityId: $entityId, args: $args) {
      ... on FirmEntity {
        _id
        address {
          address1
          address2
          city
          country
          state
          zip
        }
        crd
        entityName
        phone
        primaryEmail
      }
    }
  }
`;

const UPDATE_BRANCH = gql`
  mutation UpdateBranch(
    $branchId: ID!
    $branchName: String
    $phoneNumber: String
    $email: String
    $address1: String
    $address2: String
    $city: String
    $state: String
    $zip: String
    $country: String
  ) {
    updateBranch(
      branch_id: $branchId
      branch_name: $branchName
      phone_number: $phoneNumber
      email: $email
      address_1: $address1
      address_2: $address2
      city: $city
      state: $state
      zip: $zip
      country: $country
    ) {
      _id
      branch_name
      phone_number
      email
      address_1
      address_2
      city
      state
      zip
      country
      # aum
      # firm_id {
      #   _id
      # }
      # advisor_id {
      #   _id
      # }
    }
  }
`;

export { UPDATE_FIRM, UPDATE_BRANCH };
